import { render, staticRenderFns } from "./program-attendee-attendances.vue?vue&type=template&id=10b9540a&"
import script from "./program-attendee-attendances.vue?vue&type=script&lang=js&"
export * from "./program-attendee-attendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports